var React = require('react');

function Server (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"40","height":"40","rx":"20","fill":"#3645D4","key":0}),React.createElement("path",{"d":"M26.25 14.2821C26.25 15.4966 23.4518 16.4812 20 16.4812C16.5482 16.4812 13.75 15.4966 13.75 14.2821M26.25 14.2821C26.25 13.0676 23.4518 12.083 20 12.083C16.5482 12.083 13.75 13.0676 13.75 14.2821M26.25 14.2821V25.7173C26.25 26.9318 23.4518 27.9163 20 27.9163C16.5482 27.9163 13.75 26.9318 13.75 25.7173V14.2821M26.25 19.9069C26.25 21.1214 23.4518 22.106 20 22.106C16.5482 22.106 13.75 21.1214 13.75 19.9069","stroke":"white","strokeWidth":"0.833333","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Server.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = Server;

Server.default = Server;
